import React from 'react';
import * as Types from 'pages/Features/typings';

import GroupEmail from './GroupEmail';
import GroupMessage from './GroupMessage';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';

interface Props {
  setFieldValue: (field: string, value: any) => void;
  values: Types.FeatureValues;
}

function GroupMessaging({ values, setFieldValue }: Props) {
  return (
    <Card>
      <CardHeader
        title="Group Messaging"
        subheader="Allow your organization to bulk communicate with people in their search results. The
            maximum for each of these actions is 100 people."
      />
      <Divider />
      <CardContent>
        <GroupEmail onChange={setFieldValue} value={values.client.settings.groupEmail.enabled} />
        <GroupMessage
          onChange={setFieldValue}
          value={values.client.settings.groupMessage.msTeams}
        />
      </CardContent>
    </Card>
  );
}

export default GroupMessaging;
